export enum ENUM__float_point_precision {
  UNKNOWN = 'unknown',

  FLOAT_8 = 'bfloat16', //8-bit floating point, newer NVIDIA formats (e.g. H100).
  FLOAT_16 = 'float16', //16-bit float (half precision).
  FLOAT_32 = 'float32', //Standard 32-bit floating point (single precision).
  FLOAT_64 = 'float64',

  BFLOAT_16 = 'bfloat16', //Brain Float 16, optimized for AI workloads.

  UINT_8 = 'uint8',

  INT_8 = 'int8',
  INT_16 = 'int16',
  INT_32 = 'int32',
  INT_64 = 'int64',

  BOOL = 'bool',

  COMPLEX_64 = 'complex64',
  COMPLEX_128 = 'complex128',
}
